<template>
  <div class="line-items-table">
    <Header />

    <div class="line-items-table-body">
      <LineItems />
      <Subtotal />
      <Discount />
      <TaxSummaries />
      <Total />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import Header from "./LineItemTable/Header.vue";
import LineItems from "./LineItemTable/LineItems.vue";
import Subtotal from "./LineItemTable/Subtotal.vue";
import Discount from "./LineItemTable/Discount.vue";
import TaxSummaries from "./LineItemTable/TaxSummaries.vue";
import Total from "./LineItemTable/Total.vue";

export default {
  components: {
    Header,
    LineItems,
    Subtotal,
    Discount,
    TaxSummaries,
    Total
  },

  props: {
    invoice: { type: Object }
  },

  watch: {
    "invoice": function (newVal) {
      this.updateInvoice(newVal);
    }
  },

  created () {
    this.updateInvoice(this.invoice);
  },

  methods: {
    ...mapMutations("lineItemsTable", [
      "updateInvoice"
    ])
  }
};
</script>
